import { render, staticRenderFns } from "./h5Content.vue?vue&type=template&id=fd87981e&scoped=true"
import script from "./h5Content.vue?vue&type=script&lang=js"
export * from "./h5Content.vue?vue&type=script&lang=js"
import style0 from "./h5Content.vue?vue&type=style&index=0&id=fd87981e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd87981e",
  null
  
)

export default component.exports